import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ActiveCheckinsRedux = createActions({
  ActiveCheckinsExcelRequest: [''],
  ActiveCheckinsExcelSuccess: [''],
  ActiveCheckinsExcelError: ['error'],
},
{
  prefix: 'ACTIVE_CHECKINS_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = ActiveCheckinsRedux
export const ActiveCheckinsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const ActiveCheckinsExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const ActiveCheckinsExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const ActiveCheckinsExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ActiveCheckinsExcelRequest]: ActiveCheckinsExcelRequest,
  [Types.ActiveCheckinsExcelSuccess]: ActiveCheckinsExcelSuccess,
  [Types.ActiveCheckinsExcelError]: ActiveCheckinsExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ActiveCheckinsRedux.js